// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { LoadingProgress } from "imagus-components";
import CreateTierForm from "../../components/quotes/CreateTierForm";
import { createTier, updateTier } from "../../actions/quoteAdminActions";

type CreateTierFormReduxPropsType = {
  onClose: Function,
  tier?: { [key: string]: * },
  actions: { createTier: Function, updateTier: Function }
};

class CreateTierFormRedux extends Component<CreateTierFormReduxPropsType, *> {
  createTier = (
    name: string,
    authorisedDistributer: string,
    authorisedReseller: string,
    standardDistributer: string,
    standardReseller: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.createTier(
      name,
      authorisedDistributer,
      authorisedReseller,
      standardDistributer,
      standardReseller,
      doneCallback,
      failCallBack
    );
  };

  updateTier = (
    id: string,
    name: string,
    authorisedDistributer: string,
    authorisedReseller: string,
    standardDistributer: string,
    standardReseller: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.updateTier(
      id,
      name,
      authorisedDistributer,
      authorisedReseller,
      standardDistributer,
      standardReseller,
      doneCallback,
      failCallBack
    );
  };

  render(): React$Element<*> {
    return (
      <CreateTierForm
        tier={this.props.tier}
        onClose={this.props.onClose}
        createTier={this.createTier}
        updateTier={this.updateTier}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ createTier, updateTier }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTierFormRedux);
